import { useEffect, useMemo, useState } from "react";

import { useMatrix } from "~/context/MatrixContext";
import { useRooms } from "~/hooks/useRooms";
import {
  list,
  subscribeScheduledMessages,
  type ScheduledMessageRow,
} from "~/lib/scheduled-messages";

export function useScheduledMessages(): {
  items: ScheduledMessageRow[];
  isAvailable: boolean;
} {
  const { userId } = useMatrix();
  const rooms = useRooms();
  const [items, setItems] = useState<ScheduledMessageRow[]>([]);
  const visibleRoomIds = useMemo(() => new Set(rooms.map((room) => room.id)), [rooms]);

  useEffect(() => {
    let cancelled = false;
    const refresh = () => {
      if (!userId) {
        setItems([]);
        return;
      }
      void list(userId).then((rows) => {
        if (!cancelled) setItems(rows.filter((row) => visibleRoomIds.has(row.roomId)));
      });
    };
    refresh();
    const unsubscribe = subscribeScheduledMessages(refresh);
    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, [userId, visibleRoomIds]);

  return { items, isAvailable: userId !== null };
}
